export function getLocalizedValue(value: any) {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'object' && !Array.isArray(value)) {
    if (Object.prototype.hasOwnProperty.call(value, 'en-US')) {
      return value['en-US'];
    }

    const firstLocaleKey = Object.keys(value).find((key) => key !== 'sys');
    if (firstLocaleKey) {
      return value[firstLocaleKey];
    }
  }

  return value;
}

export function getEntryField(entry: any, fieldName: any) {
  return getLocalizedValue(entry?.fields?.[fieldName]);
}

export function getContentfulField(entry: unknown, fieldName: string): unknown {
  if (!entry || typeof entry !== 'object') return undefined;
  const fields = (entry as { fields?: unknown }).fields;
  if (!fields || typeof fields !== 'object') return undefined;
  return (fields as Record<string, unknown>)[fieldName];
}
